export function parseJsonString(value) {
    try {
        return JSON.parse(value);
    }
    catch (error) {
        return value;
    }
}
//# sourceMappingURL=parse-json-string.js.map